<template>
  <div>
    <section class="has-listing-table">
      <div class="level no-margin">
        <div class="level-left">
          <h3 class="no-padding">Transactions</h3>
          <div class="level-item">
            <a @click.prevent="handleUnmatch" style="padding: 2px 10px 0;">
              Unmatch
            </a>
          </div>
        </div>
        <div class="level-right page-configs">
          <b-dropdown
            position="is-bottom-left"
            @active-change="onDropdownActiveChange"
          >
            <template #trigger>
              <a class="navbar-item navbar-mdi-tune-dropdown">
                <button class="button" data-cy="transaction-config-button">
                  <span class="mdi mdi-table-cog mdi-24px mdi-dark"></span>
                </button>
              </a>
            </template>
            <form>
              <div class="filter-config-modal-body">
                <!-- Fixed header that won't scroll -->
                <div class="filter-config-header">
                  <b-field label="Column Configuration"></b-field>
                  <div style="padding: 4px 0;">
                    <b-checkbox v-model="selectAll" @input="toggleSelectAll">
                      <strong>Select All</strong>
                    </b-checkbox>
                  </div>
                </div>
                <!-- Scrollable content section -->
                <section class="filter-config-list">
                  <div
                    v-for="(column, index) in columns"
                    :key="index"
                    class="control"
                  >
                    <div v-if="column.label != ''">
                      <b-dropdown-item
                        aria-role="list"
                        :focusable="false"
                        custom
                        paddingless
                      >
                        <b-checkbox
                          @input="saveFieldConfig()"
                          v-model="column.visible"
                        >
                          {{ column.label }}
                        </b-checkbox>
                      </b-dropdown-item>
                    </div>
                  </div>
                </section>
              </div>
            </form>
          </b-dropdown>
        </div>
      </div>
      <!-- Rest of the template remains unchanged -->
      <div class="enable-select-text">
        <circul8-table
          table-name="Transactions"
          @clickcheck="checkCheckBox"
          @checkedAll="checkedAllData"
          :checkedRows="checkedRow"
          :records="tableData"
          :fields="columns.filter(col => col.visible !== false)"
          :usePropRecords="true"
          :listingComponent="true"
          :isCheckable="true"
          :maxTextLength="'24'"
          :isLoading="isDataLoading"
          @querySet="searchByFilter"
          :backendSortingEnabled="true"
          @backendSort="sortData"
          :showEditButton="false"
          :enableSwitchAction="false"
          :routeNext="false"
          :showViewButton="false"
          @loadNextPage="pullNextPage"
          :enableInfiniteScroll="true"
          :hasNextData="nextData"
          :hasPreviousData="previousData"
          @loadPreviousPage="pullPreviousPage"
          :isCheckAll="false"
          :newTableHeight="newTableHeight"
        />
        <div class="records-displayed" v-if="totalRecords > 0">
          <span v-if="isCheckedAll"> All selected, </span>
          <span v-if="checkedData.length > 0 && !isCheckedAll"
            >{{ checkedData.length }} selected,
          </span>
          <span v-if="currentPage * 50 + 50 < totalRecords"
            >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
            {{
              currentPage > 0
                ? nextPageCursor
                  ? currentPage * 50 - 50 + tableData.length
                  : totalRecords
                : tableData.length
            }}
            records out of {{ totalRecords }} records</span
          >
          <div v-else>
            <span v-if="currentPage == 0">
              displaying 0 - {{ totalRecords }} records out of
              {{ totalRecords }} records
            </span>
            <span v-else>
              displaying {{ currentPage * 50 - 50 }} -
              {{ totalRecords }} records out of {{ totalRecords }} records
            </span>
          </div>
        </div>
      </div>
    </section>
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="false"
    ></b-loading>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import Multiselect from "vue-multiselect";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import Circul8Table from "../../components/Circul8Table.vue";
import ManualMatching from "@/components/DataManagement/ManualMatching.vue";
import CDFTransactionDataService from "../../services/CDFTransactionDataService";
import DataManagementService from "../../services/DataManagementImportService";
import UtilityMixin from "@/mixins/UtilityMixin";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
import BulkTransactionExport from "@/components/DataManagement/BulkTransactionExport.vue";
import BulkComment from "@/components/DataManagement/BulkComment.vue";
import { FieldType } from "../../constants/FieldType";
import * as dayjs from "dayjs";
import { UserGroup } from "@/services/UserGroups";
import { mapGetters } from "vuex";
let screenPixelSize;
let pixelRatio;
export default {
  name: "DataManagementTransactions",
  mixins: [UtilityMixin, UserPermissionMixin],
  components: {
    Circul8Table
  },
  props: {
    customerId: { type: Number, default: -1 },
    newTableHeight: { type: [Number, String], default: null },
    refreshTrigger: { type: Boolean, default: false },
    matchClicked: { type: Number, default: 0 } // Counter to track match button clicks
  },
  data() {
    return {
      checkedData: [],
      checkedRow: [],
      map1: new Map(),
      isCheckedAll: false,
      checkedDataMap: new Map(),
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: false,
      nextData: false,
      previousData: false,
      currentPage: 0,
      query: "",
      isDataLoading: false,
      isBulkExportModal: false,
      customer: "",
      form: [],
      customers: [],
      cdf_Transaction_sheet: [],
      customerDataService: new CustomerProfileDataService(),
      CDFTransactionDataService: new CDFTransactionDataService(),
      DataManagementService: new DataManagementService(),
      columns: [],
      tableData: [],
      subHeight: 280, // Reduced to better fit with table height
      switchCustomerId: null,
      switchCustomerViewEnabled: false,
      isBulkCommentModal: false,
      isManualMatchingModal: false,
      exportLargeCount: 65000,
      selectAll: true
    };
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "mappedCustomer",
      "switchCustomerView"
    ]),
    isEditAllowed() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) //||
        // this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE) ||
        // this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      } else {
        return false;
      }
    },
    titleStack() {
      return [
        { url: "#", name: "Data Management" },
        { url: "/datamangement/transaction", name: "Transactions" }
      ];
    }
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    if (this.mappedCustomer && this.mappedCustomer.length > 0) {
      this.switchCustomerViewEnabled = true;
      this.getCustomerById();
    } else {
      this.fetchCustomerData();
    }
    if (this.customerId || this.switchCustomerId) {
      this.getCustomerById();
    }
    // Check if columns are saved in the custom configuration then fetch them
    if (localStorage.getItem("transactionMappingFields")) {
      const visibleFields = JSON.parse(
        localStorage.getItem("transactionMappingFields")
      );
      // Apply visibility settings from localStorage
      this.columns.forEach(c => {
        c.visible = visibleFields.indexOf(c.field) >= 0;
      });
    }
    // Adjust table height initially and on window resize
    this.$nextTick(() => {
      this.adjustHeight();
      window.addEventListener("resize", this.adjustHeight);
    });
  },

  // Clean up event listener when component is destroyed
  beforeDestroy() {
    window.removeEventListener("resize", this.adjustHeight);
  },

  watch: {
    refreshTrigger(newVal) {
      if (newVal && this.customerId > 0) {
        this.refreshData();
      }
    },
    // Watch for match button clicks
    matchClicked(newVal, oldVal) {
      if (newVal !== oldVal && this.customerId > 0) {
        // Reset only selection state without affecting filters or pagination
        this.map1 = new Map();
        this.checkedRow = [];
        this.isCheckedAll = false;
        this.checkedData = [];
        this.checkedDataMap = new Map();
        this.tableData = [];

        // Notify parent of cleared selections
        this.$emit("selectedRows", []);

        // Fetch fresh data with current query to preserve filters and pagination
        const queryToUse = this.query || "";
        this.fetchTransactionData(queryToUse);
      }
    },
    columns: {
      handler(newColumns) {
        // Update selectAll checkbox when columns change
        this.selectAll = newColumns.every(
          column => column.field === "actions" || column.visible !== false
        );
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    toggleSelectAll() {
      this.columns.forEach(column => {
        if (column.field !== "actions") {
          column.visible = this.selectAll;
        }
      });
      this.columnsForConfig = [...this.columns];
      this.saveFieldConfig();
    },
    // Method to refresh data after matching
    refreshData() {
      // Reset selection-related state, preserve filters and other settings
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.tableData = [];

      // Clear any existing selections
      this.$emit("selectedRows", []);

      // Fetch fresh data with current query to maintain filters
      const queryToUse = this.query || "";
      this.fetchTransactionData(queryToUse);
    },

    // Add to methods section in TransactionMappingTable.vue
    saveFieldConfig() {
      // Get visible column fields
      const visibleFields = this.columns
        .filter(col => col.visible === true)
        .map(col => col.field);

      // Save to localStorage
      localStorage.setItem(
        "transactionMappingFields",
        JSON.stringify(visibleFields)
      );

      // Force a re-render of the table with only visible columns
      this.$nextTick(() => {
        if (this.$refs.circul8Table) {
          this.$refs.circul8Table.$forceUpdate();
        }
        // After the DOM update, recalculate the table height to fill available space
        this.adjustHeight();
      });
    },
    manualMatchingCancel() {
      this.isManualMatchingModal = false;
    },
    saveBulkComment(data) {
      this.isBulkCommentModal = false;
      this.CDFTransactionDataService.saveBulkComment(
        this.customer.id,
        this.checkedData.map(records => records.id),
        this.query,
        this.isCheckedAll,
        data
      ).subscribe(
        () => {
          this.checkedData = [];
          this.map1 = new Map();
          this.checkedRow = [];
          this.isCheckedAll = false;
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Comment(s) Created!",
            onConfirm: () => this.getCustomerById()
          });
        },
        e => {
          this.$buefy.dialog.alert({
            title: "Error",
            message: e.message
          });
          this.isLoading = false;
          console.log(e);
        }
      );
    },
    cancelBulkComment() {
      this.isBulkCommentModal = false;
    },
    BulkComments() {
      if (this.checkedData.length > 0) {
        this.isBulkCommentModal = true;
      } else {
        this.$buefy.dialog.alert({
          title: "Comment is Not Possible",
          message: "Please select at least one record"
        });
      }
    },
    viewConfirmExport() {
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isBulkExportModal = false;
    },
    viewCancel() {
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isBulkExportModal = false;
    },
    additionalBulkCheck(bulkAction) {
      let msg = "";
      if (this.totalRecords < this.exportLargeCount) {
        msg =
          `Are you sure you want to export ` +
          (this?.isCheckedAll
            ? `all`
            : `selected ` + this?.checkedData?.length) +
          ` records?`;
      } else {
        msg = `Are you sure you want to export more than 65000 records? Exported file will be sent to your email address`;
      }

      if (this.checkedData.length > 50 || this.isCheckedAll) {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          message: msg,
          trapFocus: true,
          onConfirm: value => this.exportAllTransactions(value, bulkAction)
        });
      } else {
        this.functionCallingMethod(false, bulkAction);
      }
    },
    exportTransactions() {
      try {
        this.CDFTransactionDataService.exportTransactions(
          this.customer.id,
          "Transactions",
          this.checkedData.map(records => records.id)
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Export is Not Possible",
          message: e.message
        });
      }
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
    },
    async exportAllTransactions() {
      this.isLoading = true;
      try {
        this.CDFTransactionDataService.exportAllTransactions(
          this.customer.id,
          "Transactions",
          this.query,
          this.totalRecords
        ).subscribe(
          () => {
            this.isLoading = false;
          },
          e => {
            this.isLoading = false;
            console.log(e);
          }
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: e.message
        });
      }
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
    },
    functionCallingMethod(value, bulkAction) {
      this.isCheckedAll = false;
      switch (bulkAction) {
        case "exportTransactions":
          this.exportTransactions();
          break;
      }
    },
    handleUnmatch() {
      try {
        if (!this.checkedData.length) {
          this.$buefy.dialog.alert({
            title: "Unmatch is Not Possible",
            message: "Please select at least one record to unmatch."
          });
          return;
        }
        this.CDFTransactionDataService.manualUnmatch(
          this.customer.id,
          this.checkedData.map(record => record.id)
        ).subscribe(
          () => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Selected entries have been unmatched!"
            });
            this.checkedData = [];
            this.map1 = new Map();
            this.checkedRow = [];
            this.isCheckedAll = false;
            this.checkedDataMap = new Map();
            // Reset table data before fetching
            this.tableData = [];
            this.currentPage = 0;
            this.nextPageCursor = null;
            this.nextData = false;
            this.previousData = false;
            this.fetchTransactionData(this.query);
          },
          e => {
            this.$buefy.dialog.alert({
              title: "Error",
              message:
                e.response?.data?.detail ||
                e.message ||
                "An error occurred while unmatching."
            });
            console.log(e);
          }
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Unmatch is Not Possible",
          message: e.message
        });
      }
    },
    getCustomerById() {
      let customerId = this.customerId
        ? this.customerId
        : this.switchCustomerId;
      if (this.mappedCustomer.length > 0) {
        customerId = this.mappedCustomer[0];
      }
      this.customerDataService.getCustomerById(customerId).subscribe(
        response => {
          this.customer = response;
          this.changeCustomer();
        },
        e => {
          console.log(e);
        }
      );
    },
    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      // Save current page selections before changing page
      if (this.checkedRow && this.checkedRow.length > 0) {
        this.checkedDataMap.set(this.currentPage, [...this.checkedRow]);

        // Update the aggregated checkedData array
        this.checkedData = [];
        this.checkedDataMap.forEach(data => {
          this.checkedData.push(...data);
        });

        // Emit updated selections with all checked rows across all pages
        this.$emit("selectedRows", this.checkedData);
      }
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      //query_part = [...new Set(query_part)];
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          "&" + query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        //this.query = "&" + this.query;
        this.fetchTransactionData(this.query, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      // Save current page selections before changing page
      if (this.checkedRow && this.checkedRow.length > 0) {
        this.checkedDataMap.set(this.currentPage, [...this.checkedRow]);

        // Update the aggregated checkedData array
        this.checkedData = [];
        this.checkedDataMap.forEach(data => {
          this.checkedData.push(...data);
        });

        // Emit updated selections with all checked rows across all pages
        this.$emit("selectedRows", this.checkedData);
      }
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = "&" + query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query =
          "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchTransactionData(this.query, "prev");
    },
    checkedAllData(value) {
      this.isCheckedAll = value;
      if (!this.isCheckedAll) {
        this.checkedRow = [];
        this.map1 = new Map();
        this.checkedDataMap = new Map();
        this.checkedData = [];
      } else {
        this.checkedDataMap.set(this.currentPage, [...this.tableData]);
        // Update aggregated checkedData with all selections
        this.checkedData = [...this.tableData];
      }
      this.$emit("selectedRows", this.checkedData);
    },
    checkCheckBox(d) {
      // select all should be false now
      const total_checked = this.checkedData.length;
      const indexes = [];
      //getting the index of the checked rows
      d.forEach(element => {
        const index = this.tableData.findIndex(object => {
          return element.id === object.id;
        });
        indexes.push(index);
      });
      // create 2 dictionary. one with indexes for showing current page selected another with checked row value
      this.map1.set(this.currentPage, indexes);

      // Always store a copy of the selection to avoid reference issues
      if (d.length > 0) {
        this.checkedDataMap.set(this.currentPage, [...d]);
      } else {
        !this.isCheckedAll && this.checkedDataMap.set(this.currentPage, []);
      }
      this.checkedRow = d;
      this.checkedData = [];
      // converting mapped data into array for bulk operations
      this.checkedDataMap.forEach(element => {
        this.checkedData.push(...element);
      });
      // if checked all is true and deselect any
      if (this.isCheckedAll && total_checked > this.checkedData.length) {
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
        this.map1 = new Map();
      }
      // Emit the aggregated checked data from all pages instead of just the current page
      this.$emit("selectedRows", this.checkedData);
    },
    searchByFilter(filterQuery) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
      this.query = "&" + filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      // Maintaining sort column & order in separate varaibles instead of this.query as it becomes difficult to replace & maintain
      // sort column & order part of this.query string. We should maintain query params in associative array instead of string
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn + "&";
        query += "&order_by" + "=" + this.lastSortOrder + "&";
        query += this.query;
      } else {
        query = this.query;
      }
      this.fetchTransactionData(query);
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");

      const oldOrderField = "&order_field" + "=" + this.lastSortColumn + "&";
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder + "&";
      const newOrderField = "&order_field" + "=" + field + "&";
      const newOrderValue = "&order_by" + "=" + order + "&";

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchTransactionData(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },
    changeCustomer() {
      this.columns = [];
      this.tableData = [];
      this.totalRecords = 0;
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
      if (this.customer?.id) {
        this.fetchCDFTrasactionData(this.customer.id);
      }
    },

    prepareColumns(data) {
      // dynamically generate columns based on customer and stream
      const cdf_columns = data[0]["template_fields"];
      this.columns = [];
      this.tableData = [];
      this.columns.push({
        field: "customer_name",
        label: "Customer",
        searchable: true,
        filterKey: { customer_name: "" },
        type: "input",
        width: "200",
        visible: true
      });
      cdf_columns.forEach(e => {
        if (e.field_required == false) {
          return;
        }
        let type = "";
        let multiSelectFilter = "false";
        type = this.getFieldType(e.field_type);
        const filterKey = {};
        const allStatusVals = [];
        const editableCheck = e?.editable_check ? e.editable_check : false;
        const field_name = e.transaction_data_column;
        const label_name =
          e.field_name.charAt(0).toUpperCase() +
          e.field_name.slice(1).toLowerCase();
        if (type == "multiSelectFilter") {
          multiSelectFilter = "true";
          filterKey[field_name] = [];
          filterKey["field_name"] = "name";
        } else {
          filterKey[field_name] = "";
        }
        if (e.dropdown_field_values?.length > 0) {
          e.dropdown_field_values.forEach(element => {
            allStatusVals.push({ name: element });
          });
        }
        this.columns.push({
          field: field_name,
          label: label_name,
          searchable: true,
          filterKey: filterKey,
          type: type,
          multiSelectFilter: multiSelectFilter,
          initStatusVals: [],
          allStatusVals: allStatusVals,
          editableCheck: editableCheck,
          width: "300",
          visible: true
        });
      });
      this.columns.sort((a, b) => a?.template_field - b?.template_field);
      this.columns.push({
        field: "common_product",
        label: "Matched Product Number",
        searchable: true,
        filterKey: { common_product: "" },
        type: "input",
        width: "150",
        visible: true
      });
      this.columns.push({
        field: "common_product_name",
        label: "Matched Product Name",
        searchable: true,
        filterKey: { common_product_name: "" },
        type: "input",
        width: "150",
        visible: true
      });
      this.columns.push({
        field: "match_type",
        label: "Match Type",
        editableCheck: true,
        searchable: true,
        filterKey: {
          match_type: [],
          field_name: "name"
        },
        type: "multiSelectFilter",
        multiSelectFilter: true,
        allStatusVals: [
          { name: "Exact" },
          { name: "Like for Like" },
          { name: "Comparable" },
          { name: "NA" }
        ],
        width: "200",
        visible: true
      });
      this.columns.push({
        field: "period_of_import",
        label: "Period",
        searchable: true,
        filterKey: { period_of_import: "" },
        type: "input",
        width: "300",
        visible: true
      });
      this.columns.push({
        field: "comment",
        label: "External User Comment",
        searchable: true,
        additionalInfo: true,
        additionalInfoIcon: "mdi  mdi-information",
        additionalInfoFieldName: "comment",
        filterKey: { comment: "" },
        type: "input",
        width: "400",
        visible: true
      });
      this.columns.push({
        field: "created_at",
        label: "Imported On",
        searchable: true,
        filterKey: { created_at: "" },
        type: "dateField",
        width: "300",
        visible: true
      });
      this.columns.push({
        field: "created_by_name",
        label: "Created By",
        searchable: true,
        filterKey: { created_by_name: "" },
        type: "input",
        width: "300",
        visible: true
      });

      this.columns.push({
        field: "updated_by_name",
        label: "Updated By",
        searchable: true,
        filterKey: { updated_by_name: "" },
        type: "input",
        width: "300",
        visible: true
      });
      this.columns.push({
        field: "actions",
        label: "",
        headerClass: "is-actions",
        cellClass: "is-actions",
        visible: true,
        searchable: true,
        type: "actionSearch",
        actionSearch: true,
        filterKey: { actions: "" }
      });
      if (localStorage.getItem("transactionMappingFields")) {
        const visibleFields = JSON.parse(
          localStorage.getItem("transactionMappingFields")
        );
        this.columns.forEach(c => {
          // Only set visible to true if it's in the saved list
          c.visible = visibleFields.indexOf(c.field) >= 0;
        });
      }
      this.fetchTransactionData();
    },

    fetchCDFTrasactionData(customer_id) {
      this.isDataLoading = true;
      //here sending true for geting NA values for dropdowns
      this.CDFTransactionDataService.getCdfTransactionField(
        customer_id,
        true
      ).subscribe(
        response => {
          this.cdf_transaction_sheet = response;
          if (response.length > 0) {
            this.prepareColumns(response);
          }
          this.isDataLoading = false;
        },
        e => {
          console.log(e);
          this.isDataLoading = false;
        }
      );
    },
    fetchCustomerData() {
      this.isDataLoading = true;
      this.customerDataService.getParentCustomerList().subscribe(
        response => {
          const data = response.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.customers = data;
          this.isDataLoading = false;
        },
        e => {
          console.log(e);
        }
      );
    },
    routeToImportForm() {
      this.$router.push({
        name: "datamanagement.importform",
        params: {
          customer: this.customer,
          importType: { id: "2", name: "Transactions" }
        }
      });
    },

    prepareData(data) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        reportData["updated_at"] = this.dateToLocalDate(
          reportData["updated_at"]
        );
        reportData["created_at"] = dayjs(reportData["created_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        reportData["actions"] = "true";
        const matchType = (reportData["match_type"] || "")
          .toString()
          .trim()
          .toLowerCase();
        const normalizedMatchType = matchType.replace(/[^a-z0-9]/g, "");
        if (normalizedMatchType === "exact") {
          reportData["rowClassName"] = "success match-type-exact-row";
        } else if (normalizedMatchType === "comparable") {
          reportData["rowClassName"] = "warning match-type-comparable-row";
        } else if (normalizedMatchType === "likeforlike") {
          reportData["rowClassName"] = "primary match-type-likeforlike-row";
        } else {
          reportData["rowClassName"] = "";
        }
        dataList.push(reportData);
      }

      if (this.nextPageCursor == null) {
        // Force Vue reactivity by creating a new array reference
        this.tableData = [...this.tableData, ...dataList];
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        // Create a new array reference to trigger Vue reactivity
        this.tableData = [...dataList];
      }

      // Force Vue to detect all changes by ensuring each row is a new object reference
      this.$nextTick(() => {
        this.$forceUpdate();
      });

      //if select all checkbox clicked the show all the data for the page as checked
      if (this.isCheckedAll) {
        this.checkedRow = this.tableData;
        // When "Select All" is checked, add all rows to the aggregated selections
        if (!this.checkedDataMap.has(this.currentPage)) {
          this.checkedDataMap.set(this.currentPage, [...this.tableData]);
        }
      } else {
        // Check if we have saved selections for this page
        if (this.checkedDataMap.has(this.currentPage)) {
          // Restore checked rows directly from the map
          const savedCheckedData = this.checkedDataMap.get(this.currentPage);

          // We need to update the references to match the new data
          const newCheckedRows = [];

          // Match saved checked rows with new data by ID
          savedCheckedData.forEach(savedItem => {
            const matchingItem = this.tableData.find(
              item => item.id === savedItem.id
            );
            if (matchingItem) {
              newCheckedRows.push(matchingItem);
            }
          });

          this.checkedRow = newCheckedRows;

          // Update map1 with new indexes
          const indexes = [];
          this.checkedRow.forEach(element => {
            const index = this.tableData.findIndex(object => {
              return element.id === object.id;
            });
            if (index !== -1) {
              indexes.push(index);
            }
          });
          this.map1.set(this.currentPage, indexes);

          // Update the aggregated checkedData array with all selections
          this.checkedData = [];
          this.checkedDataMap.forEach(data => {
            this.checkedData.push(...data);
          });

          // Emit updated selections with all checked rows across all pages
          this.$emit("selectedRows", this.checkedData);
        } else {
          this.checkedRow = [];
          // Reset the aggregated selections when nothing is selected on this page
          if (this.checkedDataMap.size === 0) {
            this.checkedData = [];
            this.$emit("selectedRows", this.checkedData);
          }
        }
      }
      this.isDataLoading = false;
    },
    fetchTransactionData(query = "", scrollDir) {
      this.isDataLoading = true;

      // Ensure we include page parameter when refreshing after a match
      let finalQuery = query;
      if (
        this.matchClicked > 0 &&
        !query.includes("page=") &&
        this.currentPage > 0
      ) {
        const pageParam = "page=" + (this.currentPage + 1);
        finalQuery = query + (query ? "&" : "") + pageParam;
      }

      this.DataManagementService.getTransactionData(
        this.customer.id,
        finalQuery
      ).subscribe(
        response => {
          this.PreviousPageCursor = this.nextPageCursor
            ? this.nextPageCursor
            : this.PreviousPageCursor;
          this.nextPageCursor = response["next"];
          if (this.currentPage > 1) {
            this.previousData = true;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          } else {
            this.enableLoadMore = this.previousData = false;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          }
          this.totalRecords = response["count"];
          let tempData = [];
          if (scrollDir == "next") {
            //this.totalRecords = this.data.length + response["count"];
            if (!this.nextPageCursor) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...this.tableData, ...response["results"]];
              if (tempData.length > 100 && this.nextPageCursor != null) {
                tempData = tempData.slice(50, 150);
              }
              this.prepareData(tempData);
            }
          } else if (scrollDir == "prev") {
            //this.totalRecords = this.data.length + response["count"];
            if (this.currentPage == 0) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...response["results"], ...this.tableData];
              if (tempData.length >= 100) {
                tempData = tempData.slice(0, 100);
              }
              this.prepareData(tempData);
            }
          } else {
            this.prepareData(response["results"]);
          }
          this.isDataLoading = false;
        },
        e => {
          this.nextData = false;
          console.log(e);
          this.isDataLoading = false;
        }
      );
    },

    getFieldType(value) {
      switch (value) {
        case FieldType.TEXT:
          return "input";
        case FieldType.DATE:
          return "dateField";
        case FieldType.NUMBER:
          return "input";
        case FieldType.DROPDOWN:
          return "multiSelectFilter";
        case FieldType.NUMBERRANGE:
          return "numberRange";
        default:
          return "input";
      }
    },

    // Handles dropdown open/close events
    onDropdownActiveChange(isActive) {
      // When a dropdown is opened, adjust its height
      if (isActive) {
        this.$nextTick(() => {
          this.adjustHeight();
        });
      }
    },
    // Method to adjust the table height based on window size
    adjustHeight() {
      // Set up dropdown dimensions
      this.$nextTick(() => {
        const dropdownLists = document.querySelectorAll(".filter-config-list");
        dropdownLists.forEach((list, index) => {
          // Apply styles
          list.style.maxHeight = `${this.newTableHeight - 40}px`;
          list.style.overflowY = "auto";
        });
      });
    }
  }
};
</script>

<style scoped>
/* Standard dropdown styling with improved scrolling and fixed header */
:deep(.filter-config-modal-body) {
  display: flex;
  flex-direction: column;
  max-height: 70vh;
  width: 300px;
  padding: 0 !important;
}

:deep(.filter-config-header) {
  position: sticky;
  top: 0;
  background-color: white;
  padding: 15px 15px 10px;
  border-bottom: 1px solid #f0f0f0;
  z-index: 2;
}

:deep(.filter-config-list) {
  overflow-y: auto;
  padding: 10px 15px;
  scrollbar-width: thin;
}

/* Ensure checkbox items wrap properly */
:deep(.dropdown-item) {
  padding: 5px 10px;
  white-space: normal;
  line-height: 1.4;
  height: auto;
}

:deep(.control) {
  margin-bottom: 5px;
}

:deep(.checkbox) {
  overflow-wrap: break-word;
  word-break: break-word;
}

/* Improve scrollbar visibility */
:deep(.filter-config-list::-webkit-scrollbar) {
  width: 8px;
}

:deep(.filter-config-list::-webkit-scrollbar-track) {
  background: #f1f1f1;
  border-radius: 4px;
}

:deep(.filter-config-list::-webkit-scrollbar-thumb) {
  background: #888;
  border-radius: 4px;
}

:deep(.filter-config-list::-webkit-scrollbar-thumb:hover) {
  background: #555;
}

:deep(tr.match-type-exact-row td),
:deep(tr.match-type-comparable-row td),
:deep(tr.match-type-likeforlike-row td) {
  color: inherit !important;
}
</style>
